import React from 'react';
import {
  AddAssetEntryCard,
  EntryCardSVGIcons,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

const CreateManuallyAction = ({ i18n }) => (
  <AddAssetEntryCard
    cardClassName="create-manually-action-card"
    description={i18n.getString(_TL_('Create Manually'))}
    title={i18n.getString(_TL_('Upload Individual Elements'))}
    imageSrc={EntryCardSVGIcons.CreateManualBrandKitSVGIcon}
    isFillWidth
    onClick={() => {}}
  />
);

export { CreateManuallyAction };
